/*
 * SEAL MEDIA 2026-08-08 — fri frakt i annonseringslinja.
 *
 * Tre jobber:
 *   1. Vekting. Fraktmeldingen er hviletilstanden, ikke én av flere likestilte slides.
 *      Den står i 7 sekunder, de andre glimter forbi i 3 hver. Med to andre budskap
 *      gir det frakt ca. 70 % av tiden, og aldri mer enn 3 sekunder uten den.
 *   2. Låsing. Har kunden noe i kurven, stopper rotasjonen helt og nedtellingen blir
 *      stående. Da er det ingenting viktigere å si.
 *   3. Oppdatering. Teksten følger kurven uten sidelasting, via temaets egne
 *      hendelser on:cart:change og on:cart:add.
 *
 * Fungerer sammen med temaets AnnouncementBar-klasse i main.js framfor å erstatte den:
 * vi kaller dens egne setCurrentAnnouncement og pauseAnnouncements.
 */
(function () {
  var slide = document.getElementById('seal-fs-announcement');
  if (!slide) return;

  var bar = slide.closest('announcement-bar');
  var textEl = slide.querySelector('.seal-fs-announcement__text');
  var goal = parseInt(slide.dataset.goal, 10);
  var locked = slide.classList.contains('seal-fs-announcement--locked');

  /* ---- 1. vekting ----
   * Fraktmeldingen er hviletilstanden, ikke én av flere likestilte slides.
   * Den står i HOLD_MS, de andre glimter forbi i GLIMT_MS hver, og så er vi
   * tilbake på frakt. Med to andre budskap gir det frakt ca. 70 % av tiden,
   * og den er aldri mer enn ett kort innslag unna.
   *
   * Vi bytter ut hele rotasjonen framfor å bruke temaets faste changeDelay,
   * fordi den ikke støtter ulik visningstid per slide.
   */
  var HOLD_MS = 7000;
  var GLIMT_MS = 3000;

  /* ---- 0. stable strimmelen og den klebrige headeren ----
   * Temaets header-seksjon er sticky på top 0. Strimmelen legger seg over den
   * (z-index 8001 i snippeten), så headeren må skyves ned med strimmelens høyde,
   * ellers overlapper de. Høyden måles i stedet for å hardkodes, siden den varierer
   * med tekstlengde og skjermbredde.
   */
  (function stableTopp() {
    var seksjon = slide.closest('[id^="shopify-section"]');
    if (!seksjon) return;

    function settOffset() {
      document.documentElement.style.setProperty(
        '--seal-announcement-h',
        seksjon.offsetHeight + 'px'
      );
    }

    settOffset();
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(settOffset).observe(seksjon);
    } else {
      window.addEventListener('resize', settOffset);
    }
  })();

  /* Overstyringen installeres ALLTID, også når siden lastes med varer i kurven.
   * Første versjon hoppet over den når `locked` var sann ved innlasting, i den tro at
   * en låst strimmel uansett ikke roterer. Feil: temaets IntersectionObserver kaller
   * playAnnouncements() når strimmelen kommer i syne, og uten overstyringen var det
   * temaets egen versjon uten låsevakt som kjørte. Resultatet var at nedtellingen
   * roterte bort igjen for alle som kom til siden med noe i kurven fra før.
   * Meldt av Aleksander 08.08. Vakten inne i overstyringen håndterer låst tilstand. */
  if (bar) {
    var total = bar.querySelectorAll('.announcement').length;
    if (total > 1) {
      var neste = 1;
      var paaFrakt = true;

      bar.playAnnouncements = function () {
        bar.pauseAnnouncements();
        // Låsen må overleve at temaets IntersectionObserver kaller playAnnouncements()
        // hver gang strimmelen scrolles inn i syne. Uten denne vakten ville
        // nedtellingen begynt å rotere bort igjen så snart kunden scrollet.
        if (slide.classList.contains('seal-fs-announcement--locked')) {
          bar.setCurrentAnnouncement(0);
          return;
        }
        bar.announcementInterval = setTimeout(function tick() {
          if (paaFrakt) {
            bar.setCurrentAnnouncement(neste);
            neste = neste + 1 >= total ? 1 : neste + 1;
            paaFrakt = false;
          } else {
            bar.setCurrentAnnouncement(0);
            paaFrakt = true;
          }
          bar.announcementInterval = setTimeout(tick, paaFrakt ? HOLD_MS : GLIMT_MS);
        }, paaFrakt ? HOLD_MS : GLIMT_MS);
      };

      // pauseAnnouncements i temaet bruker clearInterval. clearTimeout og
      // clearInterval deler id-rom i nettlesere, så den rydder opp riktig.

      // Temaet kan allerede ha startet standardrotasjonen i konstruktøren.
      bar.pauseAnnouncements();
      bar.setCurrentAnnouncement(0);
      bar.playAnnouncements();
    }
  }

  /* ---- 2 og 3. oppdater og lås etter kurvens innhold ---- */
  function apply(totalCents) {
    var msg;
    var isLocked = totalCents > 0;

    if (totalCents <= 0) {
      msg = slide.dataset.msgEmpty;
    } else if (totalCents < goal) {
      msg = slide.dataset.msgLeftA + Math.ceil((goal - totalCents) / 100) + slide.dataset.msgLeftB;
    } else {
      msg = slide.dataset.msgDone;
    }
    if (textEl.textContent !== msg) textEl.textContent = msg;

    slide.classList.toggle('seal-fs-announcement--locked', isLocked);

    if (!bar) return;
    if (isLocked) {
      bar.pauseAnnouncements();
      bar.setCurrentAnnouncement(0);
    } else if (typeof bar.playAnnouncements === 'function') {
      bar.playAnnouncements();
    }
  }

  function refresh() {
    fetch(((window.theme && theme.routes && theme.routes.cart) || '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) apply(cart.total_price); })
      .catch(function () { /* behold server-rendret tekst */ });
  }

  document.addEventListener('on:cart:change', refresh);
  document.addEventListener('on:cart:add', refresh);
})();
